type YM = (id: number, param: string, action: string) => void;

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const defaultYM: YM = (id, param, action) => {
	console.warn('Яндекс метрика не найдена');
};

export const getYmFunction = () => {
	return (globalThis?.ym as YM) ?? defaultYM;
};
